<template>
  <Skeleton active :loading="skeletonLoading">
    <Spin :spinning="loading">
      <div class="list">
        <div class="item" v-for="item in dataList" @click="toPeopleDetail(item)">
          <SchoolPeople :src="item.avatar" :name="item.realName" />
        </div>
        <Empty v-if="dataList.length === 0">
          <template #description>
            <div v-if="needLoading && !store.token">请登录后浏览</div>
            <div v-else>暂无内容</div>
          </template>
        </Empty>
      </div>
      <div class="pagination">
        <Pagination
          v-model="pagination.current"
          :total="pagination.total"
          show-size-changer
          showQuickJumper
          :page-size.sync="pagination.pageSize"
        />
      </div>
    </Spin>
  </Skeleton>
</template>
<script setup lang="ts">
import { Skeleton, Spin, Pagination, Empty, message } from 'ant-design-vue'
import { useRouter } from '@/hooks/useRouter'
import { webListUser, webListUserVisitors } from '@/api/user'
import useList from '@/hooks/useList'
import { computed, onMounted, watch } from 'vue'
import useInit from '@/hooks/useInit'
import { useAppStore } from '@/store/app'

const props = defineProps<{
  university?: string
  year?: number
  needLoading: boolean
  filterKey?: 'workCity' | 'workIndustry' | 'university' | 'schoolStartDate'
}>()

const listApi = computed(() => {
  if (props.needLoading) {
    return webListUser
  }
  return webListUserVisitors
})
const store = useAppStore()

const { dataList, loading, pagination, onSearch } = useList<AnyObject>({
  getList: listApi,
  mountedRequest: false,
  formatGetListQuery(query) {
    if (props.needLoading && props.filterKey) {
      if (!store.realName) {
        return false
      }
      return {
        ...query,
        [props.filterKey]: store[props.filterKey] || '',
      }
    }
    if (!props.university) {
      return false
    }
    return {
      ...query,
      university: props.university,
      schoolStartDate: props.year,
    }
  },
})

watch(
  () => store.realName,
  (val, prevV) => {
    if (prevV === undefined && val) {
      onSearch({})
    }
  }
)

watch(
  () => [pagination.current, pagination.pageSize],
  () => {
    onSearch({})
  }
)

const { loading: skeletonLoading } = useInit(dataList)

onMounted(() => {
  if (props.needLoading && store.token) {
    onSearch({})
  } else {
    dataList.value = []
  }
})

defineExpose({
  onQuery: onSearch,
})

const router = useRouter()
function toPeopleDetail(item: AnyObject) {
  const route = router.currentRoute
  if (store.token) {
    if (item.openFlag === 'Y') {
      router.push({
        path: `/addressBook/peopleDetail/${item.userId}`,
        query: {
          form: route.path,
        },
      })
    } else {
      message.info('该校友信息未公开')
    }
  } else {
    message.info('请登录后查看')
  }
}
</script>
<style lang="less" scoped>
.list {
  overflow: hidden;
  .item {
    float: left;
    margin: 0 8px;
    cursor: pointer;
  }
}
.pagination {
  margin-top: 16px;
}
</style>
